import { CAMP } from './camp.js';
import { COMPANY_FINALE, FINALE_NPC_IDS } from './company-finale.js';
import { DESERT, DESERT_NPC_IDS } from './desert.js';
import { FOREST, FOREST_NPC_IDS } from './forest.js';
import { MEADOW } from './meadow.js';
import { MEADOW_DRAGON_NPC_IDS } from './meadow-dragon.js';
import { SNOW, SNOW_NPC_IDS } from './snow.js';
import { SWAMP, SWAMP_NPC_IDS } from './swamp.js';
/**
 * Every region's quests (ADR 0047), in the order a character walks them:
 * the camp's prologue (ADR 0066), the meadow, then the forest, the swamp,
 * the desert and the snow. Each chain's last quest sends the player to the
 * next region's quest giver. The Company's finale (ADR 0068) comes last,
 * once every recruit is home.
 */
export const REGIONS = [
    CAMP,
    MEADOW,
    FOREST,
    SWAMP,
    DESERT,
    SNOW,
    COMPANY_FINALE,
];
/** The townsfolk the regions' quests add to the bestiary (`mobs.ts`). */
export const QUEST_NPC_IDS = [
    ...MEADOW_DRAGON_NPC_IDS,
    ...FOREST_NPC_IDS,
    ...SWAMP_NPC_IDS,
    ...DESERT_NPC_IDS,
    ...SNOW_NPC_IDS,
    ...FINALE_NPC_IDS,
];
export const QUEST_NPCS = Object.assign({}, ...REGIONS.map((region) => region.npcs));
export const QUEST_KEEPERS = REGIONS.flatMap((region) => region.keepers);
export const QUEST_ITEMS = REGIONS.flatMap((region) => region.items);
/** The experience a region's creatures pay once its chain pays the rest (ADR 0047). */
export const QUEST_XP = Object.fromEntries(REGIONS.flatMap((region) => Object.entries(region.xp)));
/** What a townsperson of the quests says with nothing to give nor take, by mob id. */
export const QUEST_GREETINGS = Object.fromEntries(REGIONS.flatMap((region) => Object.entries(region.greetings)));
/** Words spoken while a story-changing quest has yet to finish. */
export const QUEST_GREETINGS_BEFORE = Object.fromEntries(REGIONS.flatMap((region) => Object.entries(region.greetingsBefore ?? {})));
//# sourceMappingURL=regions.js.map